export default function Footer() {
  return (
    <footer className="bg-[hsl(var(--espresso))] text-[hsl(var(--ivory))] pt-16 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_renewable-invest/artifacts/a94nmrrk_AIGL%20rebranded%20logo%202026.png"
                alt="AIGL"
                className="h-12 w-12 object-contain bg-white rounded-full p-1"
              />
              <div className="leading-tight">
                <div className="font-display text-xl font-bold">ASELU Investment Growth Limited</div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-white/60">AIGL · Powering Africa</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-white/70 max-w-md leading-relaxed">
              Solar farming, education and fintech — building the next generation of African
              economic infrastructure with patient capital and community impact.
            </p>
          </div>

          <div className="md:col-span-3">
            <h5 className="text-xs uppercase tracking-[0.22em] text-white/50 mb-4 font-semibold">Explore</h5>
            <ul className="space-y-3 text-sm">
              <li><a href="#about" className="hover:text-[hsl(var(--amber))] transition-colors">About AIGL</a></li>
              <li><a href="#portfolio" className="hover:text-[hsl(var(--amber))] transition-colors">Investment portfolio</a></li>
              <li>
                <a
                  href="https://aiglnewcareer.com/franchise-opportunity"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[hsl(var(--amber))] transition-colors"
                  data-testid="footer-franchise-link"
                >
                  Franchise opportunities
                  <i className="fa-solid fa-arrow-up-right-from-square text-[10px]"></i>
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h5 className="text-xs uppercase tracking-[0.22em] text-white/50 mb-4 font-semibold">Platforms</h5>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://aiglnewcareer.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[hsl(var(--amber))] transition-colors"
                  data-testid="footer-education-link"
                >
                  AIGL Career Platform
                  <i className="fa-solid fa-arrow-up-right-from-square text-[10px]"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://parachpay.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[hsl(var(--amber))] transition-colors"
                  data-testid="footer-parachpay-link"
                >
                  ParachPay Fintech
                  <i className="fa-solid fa-arrow-up-right-from-square text-[10px]"></i>
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 hover:text-[hsl(var(--amber))] transition-colors"
                  data-testid="footer-contact-link"
                >
                  Contact us
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} ASELU Investment Growth Limited. All rights reserved.</p>
          <p className="font-display italic text-[hsl(var(--amber))]">
            Support Renewable energy &amp; African growth
          </p>
        </div>
      </div>
    </footer>
  );
}
